module.exports = __webpack_public_path__ + "img/2024_05.e4977abd.jpg";